__turbopack_context__.v({
  "dropdown": "Autocomplete-module__puVsFq__dropdown",
  "input": "Autocomplete-module__puVsFq__input",
});
